import { Fade, Grid, Button } from '@material-ui/core';
import Spin from 'components/Spin';
import { enums } from 'helpers';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { savePageLoad } from 'store/Orbita/Healthcheck/actions';
import AutomaticAnticipation from 'v2/components/Pages/Financial/AutomaticAnticipation';
import BlockedTable from 'v2/components/Pages/FinancialStatement/BlockedTable';
import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';
import GlobalWarning from 'v2/components/Shared/GlobalWarning';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { Space } from 'v2/components/Shared/Space';
import { sendEventToGA } from 'v2/helpers/analytics';

import type { User } from 'v2/interfaces/user';

import AvaliableTable from './components/AvaliableTable';
import Filter from './components/Filter';
import FutureTable from './components/FutureTable';
import styles from './components/styles';
import Wallet from './components/Wallet';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  isCompleted: any;
  savePageLoad: any;
  user: User;
}

export type FilterBy = 'Month' | 'Period';

class FinancialStatement extends Component<IProps, any> {
  private pageLoad = {
    startTime: 0,
    completed: false,
  };

  constructor(props: IProps) {
    super(props);
    this.pageLoad.startTime = performance.now();
    this.state = {
      loading: false,
      filterBy: 'Month',
    };
  }

  onChangeTypeFilter = (type: FilterBy) => {
    if (type === 'Month') {
      this.setState({ filterBy: 'Period' });
    } else {
      this.setState({ filterBy: 'Month' });
    }
  };

  componentDidUpdate() {
    if (!this.pageLoad.completed && this.props.isCompleted) {
      this.pageLoad.completed = true;
      this.props.savePageLoad('Extrato Financeiro', performance.now() - this.pageLoad.startTime);
    }
  }

  getAccountCurrency = () => {
    const currency = enums.ACCOUNT_CURRENCY[parseInt(localStorage.getItem('account_currency'))];
    return currency ? currency : 'BRL';
  };

  handleGoToFinancialStatementNew = () => {
    sendEventToGA({
      category: 'Novo Extrato',
      action: 'Botão',
      label: 'Experimente o novo extrato',
    });
  };

  render() {
    if (this.state.loading) {
      return <Spin />;
    } else {
      return (
        <Fade in={true} timeout={500}>
          <div>
            <GlobalWarning />
            <ChargebackAlert />

            <div className='my-title'>
              <h1 id='financial-statement-title'>Extrato Financeiro</h1>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <p>Consulte todas as transações e fique por dentro de seu saldo atual e futuro.</p>

                <Link
                  to={{
                    pathname: '/producer/financial-statement',
                    state: { from: 'financial' },
                  }}
                  onClick={this.handleGoToFinancialStatementNew}
                >
                  <Button variant='outlined'>Experimente o novo extrato</Button>
                </Link>
              </div>
            </div>

            <Space axis='vertical' size={32} />

            <Grid container spacing={2} alignItems='stretch' justify='flex-start'>
              <Grid item xs={12}>
                <Wallet buttonHistory={true} inline={true} permissionArea='financeiro' />
              </Grid>
            </Grid>
            <PermissionHide action='myeduzz:financeiro:solicitar-transferencia'>
              <div className='m16' />
              <AutomaticAnticipation />
            </PermissionHide>
            <div className='m16' />
            <Filter filterBy={this.state.filterBy} onChangeFilter={this.onChangeTypeFilter} />
            <div className='m16' />
            <div id='myFinancialTables'>
              <AvaliableTable filterBy={this.state.filterBy} />
              <div className='m32' />
              <FutureTable />
              <div className='m32' />
              <BlockedTable />
            </div>
          </div>
        </Fade>
      );
    }
  }
}

function mapStateToProps(state: any) {
  return {
    user: state.orbita.User.user,
    isCompleted:
      state.orbita.Financial.loadAvailable.isFetching === false &&
      Array.isArray(state.orbita.Financial.myExtract.data) &&
      Array.isArray(state.orbita.Financial.myFutureExtract) &&
      Array.isArray(state.orbita.Financial.myBlockedExtract),
  };
}

export default connect(mapStateToProps, { savePageLoad })(styles(FinancialStatement));
